<ion-header class="mobile-header">
  <ion-toolbar brandingBackground="primaryColor">
    <ion-buttons slot="start">
      <ion-button size="small" color="white" fill="clear" (click)="goBack()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title (click)="showProgramOptions()">
      <div class="topDvCaption">
        <div class="title">
          {{activeCardioProgram.title? activeCardioProgram.title : 'New Cardio Program'}} 
          <ion-icon name="create-outline"></ion-icon>
        </div>
        <div class="subtitle">{{activeCardioProgram.startDate | date}} 
          <span *ngIf="activeCardioProgram.endDate"> - {{activeCardioProgram.endDate | date}}</span> 
          <ion-icon name="calendar-outline"></ion-icon>
        </div>
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button size="small" color="white" shape="round" (click)="showNotes()" *ngIf="programMode === 'program'">
        <ion-icon slot="icon-only" name="list-outline"></ion-icon>
      </ion-button>
      <ion-button size="small" color="white" shape="round" [matMenuTriggerFor]="cardioMobileChangesMenu" *ngIf="(versionHistory?.length > 1 || hasDraft) && programMode === 'program'">
        <ion-icon slot="icon-only" name="arrow-undo-outline"></ion-icon>
      </ion-button>
      <ion-button color="success" size="small" fill="solid" shape="round" (click)="publishCardioProgram()">
        {{'general.publish' | translate}}
      </ion-button>
    </ion-buttons>
    <mat-menu #cardioMobileChangesMenu="matMenu" yPosition="below">
      <button mat-menu-item (click)="undoRevision()" *ngIf="versionHistory?.length > 1">{{'general.undo' | translate}}</button>
      <button mat-menu-item (click)="revertDraft()" *ngIf="hasDraft">{{'general.revert' | translate}}</button>
    </mat-menu>
  </ion-toolbar>

  <ion-toolbar class="web-header active-plan" *ngIf="programMode === 'program' && activeCardioProgram.programs[0].days.length">
    <div class="plan-wrapper">
      <div class="plan-controls">
        <div class="plan-dropdown">
          <div class="plan-heading">{{'general.day' | translate}} {{(activeDayIndex || 0) + 1}} / {{activeCardioProgram.programs[0].days.length || 0}}</div>
          <button class="plan-dropdown-btn" type="button" (click)="openDayDrawer()">
            <div class="plan-dropdown-title">{{ activeCardioProgram.programs[0].days[activeDayIndex]?.title ? activeCardioProgram.programs[0].days[activeDayIndex].title : (('general.day' | translate) + ' ' + ((activeDayIndex ?? 0) + 1)) }}</div>
            <ion-icon [name]="isDayDrawerOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>
        </div>
      </div>
    </div>
  </ion-toolbar>
  <ion-toolbar class="web-header plan-inline-toolbar" [class.is-open]="isDayDrawerOpen" *ngIf="programMode === 'program' && activeCardioProgram.programs[0].days.length">
    <div class="active-plan-inline-panel" *ngIf="isDayDrawerOpen">
      <div class="active-plan-popover" cdkDropList [cdkDropListData]="activeCardioProgram.programs[0].days" (cdkDropListDropped)="drop($event)">
        <div
          class="popover-option"
          cdkDrag
          *ngFor="let day of activeCardioProgram.programs[0].days; let i = index"
          [class.active]="i === activeDayIndex"
          (click)="onDaySelected(i)">
          <span class="drag-handle" cdkDragHandle>
            <ion-icon name="reorder-two-outline"></ion-icon>
          </span>
          <div class="option-content">
            <div class="option-title">{{ day?.title ? day.title : (('general.day' | translate) + ' ' + (i + 1)) }}</div>
          </div>
          <div class="option-actions">
            <span *ngIf="i === activeDayIndex" class="option-check-circle">
              <ion-icon class="option-check" name="checkmark-outline"></ion-icon>
            </span>
            <button
              type="button"
              class="option-menu-btn"
              mat-icon-button
              stop-propagation
              [matMenuTriggerFor]="cardioDayDrawerOptionsMenu">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </button>
            <mat-menu #cardioDayDrawerOptionsMenu="matMenu" yPosition="below">
              <button mat-menu-item (click)="editDayFromDrawer(i)">{{'general.editTitle' | translate}}</button>
              <button mat-menu-item (click)="duplicateDayFromDrawer(day, i)">{{'general.duplicate' | translate}}</button>
              <button mat-menu-item (click)="saveCategoryToLibraryFromDrawer(day, i)">{{'general.saveToLibrary' | translate}}</button>
              <button mat-menu-item (click)="deleteDayFromDrawer(i)">{{'general.delete' | translate}}</button>
            </mat-menu>
          </div>
        </div>
        <div class="ion-text-center ion-padding">
          <ion-button
            size="small"
            color="secondary"
            fill="solid"
            shape="round"
            [matMenuTriggerFor]="addDayDrawerMenu">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            <span>{{'general.tab' | translate}}</span>
          </ion-button>
          <mat-menu #addDayDrawerMenu="matMenu">
            <button mat-menu-item (click)="newDay()">{{'general.blankCat' | translate}}</button>
            <button mat-menu-item (click)="selectCategory()">{{'general.fromLibrary' | translate}}</button>
          </mat-menu>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ng-container *ngIf="!comparePaneEmbedded; else embeddedCardioBuilderContent">
  <ion-content class="ion-padding">
    <ng-container *ngTemplateOutlet="cardioBuilderContent"></ng-container>
  </ion-content>
</ng-container>
<ng-template #embeddedCardioBuilderContent>
  <div class="ion-padding compare-pane-embedded-content">
    <ng-container *ngTemplateOutlet="cardioBuilderContent"></ng-container>
  </div>
</ng-template>

<ng-template #cardioBuilderContent>
  <div class="content">

    <div class="desktop-sticky-shell ion-hide-lg-down">
      <!-- ⭐ UPDATED WEB HEADER — EXACTLY LIKE OTHER TEMPLATES -->
      <div class="web-header">
        <div class="left">
          <div class="backBtnTopPanel">
            <div>
              <h2 class="title" (click)="showProgramOptions()">
                {{activeCardioProgram.title || 'New Cardio Program'}}
              </h2>

              <!-- ⭐ NEW DATE ROW (ONLY ADDITION) -->
              <div class="date-row">
                <span class="date" (click)="editDate($event, 'startDate')">
                  {{ activeCardioProgram.startDate | date:'MMM d, y' }}
                </span>

                <span class="separator">–</span>

                <span class="date"
                  [class.placeholder]="!activeCardioProgram.endDate"
                  (click)="editDate($event, 'endDate')">

                  <ng-container *ngIf="activeCardioProgram.endDate; else addEndDate">
                    {{ activeCardioProgram.endDate | date:'MMM d, y' }}
                  </ng-container>

                  <ng-template #addEndDate>
                    {{'mealPlanBuilder.addEndDate' | translate}}
                  </ng-template>
                </span>

                <ion-icon name="calendar-outline"></ion-icon>
              </div>
              <!-- ⭐ END NEW DATE ROW -->

            </div>

          </div>
        </div>

        <div class="right">
          <ion-button size="small" (click)="undoRevision()" *ngIf="versionHistory?.length > 1 && programMode === 'program'">
            <ion-icon name="arrow-undo-outline"></ion-icon> <span>{{'general.undo' | translate}}</span>
          </ion-button>

          <ion-button size="small" (click)="revertDraft()" *ngIf="hasDraft && programMode === 'program'">
            <ion-icon name="arrow-undo-outline"></ion-icon> <span>{{'general.revert' | translate}}</span>
          </ion-button>

          <ion-button size="small" (click)="showNotes()" *ngIf="programMode === 'program'">
            <ion-icon name="chatbubble-outline"></ion-icon> {{'general.notes' | translate}}
          </ion-button>

          <ion-button size="small" color="success" (click)="publishCardioProgram()">
            <ion-icon name="save-outline"></ion-icon> {{'general.publish' | translate}}
          </ion-button>
          <ion-button size="small" class="settings-btn" fill="clear" (click)="goBack()">
            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
    <!-- END UPDATED HEADER -->

    <div class="navDiv m-hide" *ngIf="programMode === 'program' && activeCardioProgram.programs[0].days.length">
      <div class="etTabsWrapper">
        <nav class="et-tabs" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" appHorizontalScroll>
          <a class="tab" cdkDrag [cdkDragDisabled]="activeDayIndex !== i"
             *ngFor="let day of activeCardioProgram.programs[0].days; let i = index;"
             (click)="setActiveDay(i)" [class.active]="activeDayIndex === i"> 
            {{day.title}}
            <span class="action" *ngIf="activeDayIndex === i" mat-button [matMenuTriggerFor]="dayTabRowMenu">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </span>
            <mat-menu #dayTabRowMenu="matMenu" yPosition="below">
              <button mat-menu-item (click)="editDayTitle()">{{'general.editTitle' | translate}}</button>
              <button mat-menu-item (click)="duplicateDay(day, i)">{{'general.duplicate' | translate}}</button>
              <button mat-menu-item (click)="saveCategoryToLibrary(day)">{{'general.saveToLibrary' | translate}}</button>
              <button mat-menu-item (click)="deleteDay(i)">{{'general.delete' | translate}}</button>
            </mat-menu>
            <span class="moveDiv" *ngIf="activeDayIndex === i" cdkDragHandle>
              <ion-icon name="swap-horizontal-outline"></ion-icon>
            </span>
          </a>

          <ion-button size="small" color="secondary" [matMenuTriggerFor]="addDayTabMenu">
            <ion-icon name="add-outline"></ion-icon> {{'general.tab' | translate}}
          </ion-button>

          <mat-menu #addDayTabMenu="matMenu">
            <button mat-menu-item (click)="newDay()"> {{'general.blankCat' | translate}}</button>
            <button mat-menu-item (click)="selectCategory()"> {{'general.fromLibrary' | translate}}</button>
          </mat-menu>
        </nav>
      </div>
    </div>

    <ion-grid *ngIf="activeCardioProgram.programs[0].days.length">
      <ion-row>
        <ion-col>
          <div class="switchTabsDv clientFeaturePanelDetail">
            <div class="switchTabsInner">
              <div class="switchTabsFormDiv">
                <ion-reorder-group (ionItemReorder)="reorderSession($event)" disabled="false">
                  <div class="boxShadowDiv" *ngFor="let session of activeDay.sessions; let i = index;">
                    <div class="set-header">
                      <span class="set-title">{{'general.exercise' | translate}}: {{i + 1}}</span>
                      <div class="set-actions">
                        <button class="m-hide" (click)="duplicateSession(session)">
                          <ion-icon size="small" name="copy-outline"></ion-icon>
                        </button>
                        <button class="m-hide" (click)="removeSession(i)">
                          <ion-icon size="small" name="trash-outline"></ion-icon>
                        </button>
                        <ion-reorder>
                          <button type="button">
                            <ion-icon size="small" name="swap-vertical-outline"></ion-icon>
                          </button>
                        </ion-reorder>
                        <button type="button" class="d-hide" [matMenuTriggerFor]="sessionActionsMobileMenu">
                          <ion-icon size="small" name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                        <mat-menu #sessionActionsMobileMenu="matMenu" yPosition="below">
                          <button mat-menu-item (click)="duplicateSession(session)">
                            {{'general.duplicate' | translate}}
                          </button>
                          <button mat-menu-item (click)="removeSession(i)">
                            {{'general.delete' | translate}}
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                    <div class="boxShadowDiv__inner">
                      <cardio-program-exercise [session]="session" (onSetChanged)="saveCardioProgram()"></cardio-program-exercise>
                    </div>
                  </div>
                </ion-reorder-group>
              </div>

              <ion-button size="small" color="primary" class="addCommonBtn"
                *ngIf="activeDay.sessions && activeDay.sessions.length > 0" (click)="addSession()">
                <ion-icon name="add-outline"></ion-icon> {{'general.session' | translate}}
              </ion-button>

              <div class="noEexcercisePanel" *ngIf="!activeDay.sessions || activeDay.sessions.length === 0">
                <div class="noEexcercisePanel__img">
                  <img src="../../../../assets/imgs/my-program.png" alt="workout" />
                </div>
                <h3>{{'general.noSession' | translate}}.</h3>
                <ion-button size="small" color="primary" class="addCommonBtn" (click)="addSession()">
                  <ion-icon name="add-outline"></ion-icon> {{'general.session' | translate}}
                </ion-button>
              </div>

            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="noEexcercisePanel" *ngIf="!activeCardioProgram.programs[0].days.length">
      <div class="noEexcercisePanel__img">
        <img src="../../../../assets/imgs/my-program.png" alt="workout" />
      </div>
      <h3>{{'cardioProgramBuilder.addCategory' | translate}}.</h3>
      <div class="actions">
        <ion-button size="small" color="primary" class="addCommonBtn" (click)="newDay()">
          <ion-icon name="add-outline"></ion-icon> {{'cardioProgramBuilder.newCategory' | translate}}
        </ion-button>
        <ion-button size="small" color="primary" class="addCommonBtn" (click)="selectCategory()">
          <ion-icon name="add-outline"></ion-icon> {{'cardioProgramBuilder.fromLibrary' | translate}}
        </ion-button>
      </div>
    </div>

  </div>
</ng-template>
